module.exports = __webpack_public_path__ + "img/eva_gradiente.14508bb2.svg";